module.exports = __webpack_public_path__ + "static/media/logo.ee56e52c.svg";